import modalPositive from "../../../assets/sounds/effects/ModalPositive.mp3";
import { useSound } from "./useSound";

export const soundModalPostive = () => {
  const sound = useSound({src:modalPositive});

  sound.play();
};
